module.exports = __webpack_public_path__ + "static/media/SmiliesBuisiness-01.7e164c4e.jpg";